export default __webpack_public_path__ + "static/media/data.b1739ecc.webp";